import type { definitions } from '@luxuryescapes/contract-svc-accommodation'

import { isNonEmptyArray } from 'lib/array/arrayUtils'
import { assertUnreachable } from 'lib/staticAssert/staticAssertUtils'

/* ***** */
/* Utils */
/* ***** */

export function mapNonEmptyArray<T, U>(values: Array<T>, map: (value: T) => U | null | undefined): Utils.NonEmptyArray<U> | undefined {
  const mappedValues = values.flatMap((value) => {
    const mappedValue = map(value)
    return mappedValue != null ? [mappedValue] : []
  })
  if (!isNonEmptyArray(mappedValues)) return
  return mappedValues
}

export function mapOptional<T, U>(value: T | null | undefined, map: (value: T) => U): U | undefined {
  return value != null ? map(value) : undefined
}

/* *********** */
/* Sub-mappers */
/* *********** */

type ServerPromotionType = definitions['PromotionType']

export function mapPromotionType(
  serverPromotionType: ServerPromotionType,
): Pick<App.Property.Promotion, 'type' | 'isCampaign'> {
  const isCampaign = /^campaign(?:\.\w+)?$/.test(serverPromotionType)
  switch (serverPromotionType) {
    case 'campaign.dynamicFlash':
      return { type: 'dynamicFlash', isCampaign }
    case 'campaign':
      return { type: 'campaign', isCampaign }
    case 'campaign.bundle':
    case 'bundle':
      return { type: 'bundle', isCampaign }
    case 'campaign.tactical':
    case 'tactical':
      return { type: 'tactical', isCampaign }
    case 'campaign.marriottPromo':
    case 'bedbank':
      return { type: 'bedbank', isCampaign }
    default:
      assertUnreachable(serverPromotionType)
  }
}
